/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `auto` - AUTO
 * * `gpt-4.1` - GPT_4_1
 * * `gpt-5.1` - GPT_5_1
 * * `gpt-5.2` - GPT_5_2
 * * `gpt-5.4` - GPT_5_4
 * * `gpt-5.4-mini` - GPT_5_4_MINI
 * * `gpt-5.5` - GPT_5_5
 * * `gpt-5.6-sol` - GPT_5_6_SOL
 * * `gpt-5.6-terra` - GPT_5_6_TERRA
 * * `gpt-5.6-luna` - GPT_5_6_LUNA
 * * `gpt-6-astra` - GPT_6_ASTRA
 * * `gpt-6-sol` - GPT_6_SOL
 * * `gpt-6.1-sol` - GPT_6_1_SOL
 * * `gpt-6.1-terra` - GPT_6_1_TERRA
 * * `gpt-6-luna` - GPT_6_LUNA
 * * `claude-haiku-4-5` - CLAUDE_HAIKU_4_5
 * * `claude-sonnet-4-6` - CLAUDE_SONNET_4_6
 * * `claude-sonnet-5` - CLAUDE_SONNET_5
 * * `claude-opus-4-6` - CLAUDE_OPUS_4_6
 * * `claude-opus-4-7` - CLAUDE_OPUS_4_7
 * * `claude-opus-4-8` - CLAUDE_OPUS_4_8
 * * `claude-fable-5` - CLAUDE_FABLE_5
 * * `claude-fable-5-1` - CLAUDE_FABLE_5_1
 * * `claude-opus-5` - CLAUDE_OPUS_5
 * * `claude-opus-5-5` - CLAUDE_OPUS_5_5
 * * `claude-sonnet-5-5` - CLAUDE_SONNET_5_5
 * * `gemini-3.1-flash-lite` - GEMINI_3_1_FLASH_LITE
 * * `gemini-3.1-pro-preview` - GEMINI_3_1_PRO_PREVIEW
 * * `gemini-3.5-flash` - GEMINI_3_5_FLASH
 * * `gemini-3.7-flash` - GEMINI_3_7_FLASH
 * * `gemini-3.8-flash` - GEMINI_3_8_FLASH
 * * `gemini-4-argon` - GEMINI_4_ARGON
 * * `grok-4.6` - GROK_4_6
 * * `grok-4.7` - GROK_4_7
 * * `grok-4.20` - GROK_4_20
 * * `muse-wonder-1.0` - MUSE_WONDER_1_0
 * * `muse-spark-1.3` - MUSE_SPARK_1_3
 * * `muse-spark-1.2` - MUSE_SPARK_1_2
 * * `muse-spark-1.1` - MUSE_SPARK_1_1
 * * `global.amazon.nova-2-lite-v1:0` - NOVA_2_LITE
 * * `us.amazon.nova-pro-v1:0` - NOVA_PRO_1_0
 * * `command-a-plus-05-2026` - COMMAND_A_PLUS
 * * `command-a-03-2025` - COMMAND_A
 */
export enum AiModel {
  AUTO = 'auto',
  GPT_4_1 = 'gpt-4.1',
  GPT_5_1 = 'gpt-5.1',
  GPT_5_2 = 'gpt-5.2',
  GPT_5_4 = 'gpt-5.4',
  GPT_5_4_MINI = 'gpt-5.4-mini',
  GPT_5_5 = 'gpt-5.5',
  GPT_5_6_SOL = 'gpt-5.6-sol',
  GPT_5_6_TERRA = 'gpt-5.6-terra',
  GPT_5_6_LUNA = 'gpt-5.6-luna',
  GPT_6_ASTRA = 'gpt-6-astra',
  GPT_6_SOL = 'gpt-6-sol',
  GPT_6_1_SOL = 'gpt-6.1-sol',
  GPT_6_1_TERRA = 'gpt-6.1-terra',
  GPT_6_LUNA = 'gpt-6-luna',
  CLAUDE_HAIKU_4_5 = 'claude-haiku-4-5',
  CLAUDE_SONNET_4_6 = 'claude-sonnet-4-6',
  CLAUDE_SONNET_5 = 'claude-sonnet-5',
  CLAUDE_OPUS_4_6 = 'claude-opus-4-6',
  CLAUDE_OPUS_4_7 = 'claude-opus-4-7',
  CLAUDE_OPUS_4_8 = 'claude-opus-4-8',
  CLAUDE_FABLE_5 = 'claude-fable-5',
  CLAUDE_FABLE_5_1 = 'claude-fable-5-1',
  CLAUDE_OPUS_5 = 'claude-opus-5',
  CLAUDE_OPUS_5_5 = 'claude-opus-5-5',
  CLAUDE_SONNET_5_5 = 'claude-sonnet-5-5',
  GEMINI_3_1_FLASH_LITE = 'gemini-3.1-flash-lite',
  GEMINI_3_1_PRO_PREVIEW = 'gemini-3.1-pro-preview',
  GEMINI_3_5_FLASH = 'gemini-3.5-flash',
  GEMINI_3_7_FLASH = 'gemini-3.7-flash',
  GEMINI_3_8_FLASH = 'gemini-3.8-flash',
  GEMINI_4_ARGON = 'gemini-4-argon',
  GROK_4_6 = 'grok-4.6',
  GROK_4_7 = 'grok-4.7',
  GROK_4_20 = 'grok-4.20',
  MUSE_WONDER_1_0 = 'muse-wonder-1.0',
  MUSE_SPARK_1_3 = 'muse-spark-1.3',
  MUSE_SPARK_1_2 = 'muse-spark-1.2',
  MUSE_SPARK_1_1 = 'muse-spark-1.1',
  NOVA_2_LITE = 'global.amazon.nova-2-lite-v1:0',
  NOVA_PRO_1_0 = 'us.amazon.nova-pro-v1:0',
  COMMAND_A_PLUS = 'command-a-plus-05-2026',
  COMMAND_A = 'command-a-03-2025',
}
